import { Injectable, NgZone, Inject } from "@angular/core";

import { Router } from "@angular/router";

import { Observable } from "rxjs";
import { CUBIQ_BROKER, CubiqBrokerClient, TokenState } from "shared/broker-client-services";
import { LoggerService } from "@bfx/logger";
import { debug } from "console";
const logger = LoggerService.for(__dirname);

@Injectable({
  providedIn: "root",
})
export class TokenGuard {
  private isWaiting = false;
  private loginWindow: Window;
  private _hasToken = false;
  private _iframe = true;

  constructor(
    private _router: Router,
    private _zone: NgZone,
    @Inject(CUBIQ_BROKER) public broker: CubiqBrokerClient,
  ) {
    let brokerToken$: Observable<TokenState> = broker.token$;

    logger.out.info(`${this.constructor.name}() subscribed to broker.token$`);

    let subscription = brokerToken$.subscribe((tokenState) => {
      this._hasToken = TokenState.NONE !== tokenState;

      // logger.out.info(`${this.constructor.name}() this._hasToken:${this._hasToken} `);

      if (this.hasToken() && this.isWaiting == true) {
        this.isWaiting = false;

        this._zone.run(() => {
          this.closeLogin();
          this._router.navigate(["/"]);
        });
      } else if (this.hasToken() && this.isWaiting == false) {
        subscription.unsubscribe();
      } else if (this.isWaiting == true) {
        this.showLogin();
      } else {
        // TODO need something else to drive disconnects
        // logger.out.info('lost token')
        this._zone.run(() => {
          this._router.navigate(["request-token"]);
        });
      }
    });
  }

  canActivate(): boolean {
    // logger.out.info(`${this.constructor.name}.canActivate()`);
    if (this.hasToken()) {
      return true;
    } else if (this.isWaiting) {
      this.showLogin();
    } else {
      this.isWaiting = true;
      this._zone.run(() => {
        this._router.navigate(["request-token"]);
      });
    }
    return false;
  }

  // canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
  //   return this.hasToken();
  // }

  public hasToken(): boolean {
    return this._hasToken;
  }

  public showLogin(): void {
    if (this._iframe) {
      return;
    }

    this.closeLogin();
    this.loginWindow = window.open(
      "/#login=closeAfterToken",
      "Login",
      "height=600,width=580,scrollbars=no",
    );
  }

  public closeLogin(): void {
    if (this._iframe) {
      return;
    }

    if (this.loginWindow) {
      let loginWindow: Window = this.loginWindow;

      setTimeout(
        (loginWindow: Window) => {
          loginWindow.close();
        },
        2000,
        loginWindow,
      );
    }
  }
}
